import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import FeaturedBlockView from './FeaturedBlock';
import FeaturedBlockSchema from './FeaturedBlockSchema';

interface FeaturedBlockEditProps {
  data: any;
  block: string;
  onChangeBlock: (blockId: string, data: any) => void;
  selected: boolean;
}

const FeaturedBlockEdit: React.FC<FeaturedBlockEditProps> = (props) => {
  const { data, block, onChangeBlock, selected } = props;

  return (
    <>
      <FeaturedBlockView {...props} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={FeaturedBlockSchema}
          title={FeaturedBlockSchema.title}
          onChangeField={(id: string, value: any) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default FeaturedBlockEdit;
